import { sha256 } from "js-sha256";

import { CLIENT_API } from "constants/integration.constants";
import store from 'store/configureStore';

import { getUrlVars } from "utils/common";
import { sendPostMessageToParent } from "utils/iframe";
import { SCHEDULED_GAME_CATEGORY } from 'constants/game.constants';

export const exitFromSession = () => {
	const state = store.getState();
	const { exitUrl } = state.auth.session;

	if (exitUrl) {
		sendPostMessageToParent({ type: CLIENT_API.BACK_TO_HOME, value: exitUrl, mainDomain: exitUrl });
	}
	else {
		location.reload();
	}
}

export const logout = () => {
	exitFromSession();
}

export const getUser = (argUrlVars) => {
	const urlVars = argUrlVars ?? getUrlVars();

	const userName = urlVars["user"] ?? "Aram";
	const id = urlVars["id"] ?? userName + "_id";
	const apiKey = urlVars["apiKey"] ?? "1060c7b828414c498066cea8e53435e7";
	const secret = urlVars["secret"] ?? "902374A1C2";
	const currency = urlVars["currency"] ?? "USD";
	const language = urlVars["language"] ?? "EN";
	const balance = urlVars["balance"] ?? 10000;
	const isDemo = urlVars["isDemo"] ?? false;
	const urlMode = urlVars["mode"] ?? null;
	let mode = null;
	switch (urlMode) {
		case "light":
			mode = 1;
			break;
		case "dark":
			mode = 2;
			break;
		default:
			break;
	}

	const user = {
		ProjectId: apiKey,
		LanguageId: language,
		IsDemo: isDemo,
		User:
			urlVars["user"] !== "Guest"
				? {
					Id: id,
					UserName: userName,
					CurrencyId: currency,
					Balance: balance
				}
				: null,
		Urls: {
			ExitUrl: "return_url",
			DepositUrl: "deposit_url",
			LoginUrl: "Login_url"
		},
		gameCategory: SCHEDULED_GAME_CATEGORY,
		mode
	};

	const sign = sha256.hmac(secret, JSON.stringify(user));

	return { user, sign };
};